import ErrorAlert from '../ErrorAlert';
import EditContext from './EditContext';
import React, { useContext } from 'react';

function EditErrorOnSaveAlert() {
	const { errorOnSave, axiosError } = useContext(EditContext);
	return errorOnSave ? <ErrorAlert error={axiosError || null} /> : null;
}

export default EditErrorOnSaveAlert;
